import React from 'react';
import TurboConnectTable from './TurboConnectTable';
export default function TurboConnectStatisticsOverview() {
  return (
    <div>
      <TurboConnectTable />
    </div>
  );
}
